<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.6357 22.6923C25.3696 22.6923 29.2072 18.7317 29.2072 13.8461C29.2072 8.96055 25.3696 5 20.6357 5C15.9019 5 12.0643 8.96055 12.0643 13.8461C12.0643 18.7317 15.9019 22.6923 20.6357 22.6923ZM13.1357 12.5C13.1357 11.1193 14.255 10 15.6357 10H25.6357C27.0165 10 28.1357 11.1193 28.1357 12.5C28.1357 13.8807 27.0165 15 25.6357 15H15.6357C14.255 15 13.1357 13.8807 13.1357 12.5ZM20.6357 20C19.6002 20 18.7607 19.1605 18.7607 18.125C18.7607 17.0895 19.6002 16.25 20.6357 16.25C21.6713 16.25 22.5107 17.0895 22.5107 18.125C22.5107 19.1605 21.6713 20 20.6357 20Z"
      class="fill-current"
    />
    <path
      d="M5.63574 22.6923L12.009 19.4036C13.5922 22.665 16.8606 24.9039 20.6357 24.9039C24.4109 24.9039 27.6793 22.665 29.2625 19.4036L35.6357 22.6923L34.7041 27.5H6.56742L5.63574 22.6923Z"
      class="fill-current"
    />
    <path d="M7.05189 30L7.7786 33.75H33.4929L34.2196 30H7.05189Z" class="fill-current" />
    <path
      d="M15.6357 12.6035C15.6357 11.895 16.2719 11.356 16.9708 11.4725L18.5375 11.7336C19.027 11.8152 19.3857 12.2387 19.3857 12.7349C19.3857 13.2955 18.9313 13.75 18.3707 13.75H16.7823C16.1491 13.75 15.6357 13.2367 15.6357 12.6035Z"
      class="fill-current"
    />
    <path
      d="M21.8857 12.7349C21.8857 12.2387 22.2445 11.8152 22.734 11.7336L24.3007 11.4725C24.9996 11.356 25.6357 11.895 25.6357 12.6035C25.6357 13.2367 25.1224 13.75 24.4892 13.75H22.9008C22.3402 13.75 21.8857 13.2955 21.8857 12.7349Z"
      class="fill-current"
    />
  </svg>
</template>
